import styled from '@emotion/styled';
import { DialogContent } from '~/shared/components/Dialog/DialogContent';

export const StyledMarketSelectorDialogContent = styled(DialogContent)(({ theme }) => ({
	color: theme.colors.black,
}));
